import './CycoPage.less';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import _ from 'lodash';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import { CREDIT_TYPE } from '../../../framework/App/AppConstants';
import TwoColumnLayout from '../../../framework/components/Templates/TwoColumnLayout/TwoColumnLayout';
import BodyHeader from '../../../shared-components/BodyHeader/BodyHeader';
import AsideContentContainer from '../../components/AsideContentContainer/AsideContentContainer';
import CycoPageForm from './CycoPageForm';

const LOCALE_PREFIX = 'US/pages/CycoPage/CycoPage';

export class CycoPage extends Component {
    static propTypes = {
        isCore: PropTypes.bool.isRequired,
        coreOffer: PropTypes.object,
        intl: intlShape.isRequired,
        isReuse: PropTypes.bool.isRequired,
        onComponentDidMount: PropTypes.func.isRequired
    };

    static defaultProps = {
        isCore: false,
        isReuse: false,
        coreOffer: {},
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount();
    }


    render() {
        const { isCore, isReuse, intl, coreOffer } = this.props;

        // utils
        const pageName = isCore ? 'cycocorepage' : 'cycopage';
        const isAcq = !isReuse;
        const acqOrReuse = isAcq ? 'acq' : 'reuse';

        // set messaging for aside content
        let defaultMessage = 'cyco-message';
        if (isReuse) {
            // We want to update the HTML head title for Reuse to "PayPal Checkout" as CAPE generally shows "Apply for PayPal Credit".
            document.title = intl.formatMessage({id: `${LOCALE_PREFIX}.cyco-page-html-head-title-reuse`});
        }
        if (isCore) {
            defaultMessage = `cycopagecore-message-${acqOrReuse}`;
        }
        const aside = (
            <AsideContentContainer
                defaultMessage={defaultMessage}
                asideContainerStyle="aside-content-cyco"
                creditType={CREDIT_TYPE.CORE}
                isCore={isCore}
            />);

        const classes = [
            'CycoPage',
            (isCore ? 'CycoPage--core' : 'CycoPage--ni'),
            (isAcq ? 'CycoPage--acquisition' : 'CycoPage--reuse')
        ];

        return (
            <TwoColumnLayout pageName={classes.join(' ')} overrideAside={aside}>
                <BodyHeader paypalLogo={false} />
                <CycoPageForm
                    pageName={pageName}
                    isCore={isCore}
                    coreOffer={coreOffer}
                    isAcq={isAcq}
                    isReuse={isReuse}
                    acqOrReuse={acqOrReuse}
                />
            </TwoColumnLayout>
        );
    }
}

export const mapStateToProps = (state, ownProps) => ({
    isReuse: _.get(state, 'serverData.isReuse', false),
    coreOffer: ownProps.isCore ? _.get(state, 'serverData.cycoFinancingOptions[0]') : undefined
});

export const mapDispatchToProps = (dispatch, ownProps) => {
    const pageName = _.get(ownProps, 'isCore') ? 'cycocorepage' : 'cycopage';
    return {
        onComponentDidMount() {
            dispatch(trackTransition(`pp_credit_${pageName}`, `prepare_pp_credit_${pageName}`));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CycoPage));
